import { isGoLightAdmin } from '@/utils/requestHandler.js'

export default {
   data() {
      return {
         setCurrentNavBar: this.$vnode.key,
         isGoLightAdmin: false
      }
   },
   async created() {
      this.isGoLightAdmin = await isGoLightAdmin()
   },
   methods: {
      /* Simulates a click on the div="page" of the parent to close the Swisscom Side Menu, since it doesn't
    automatically closes after a navigation (yet) */
      closeMenu() {
         this.$parent.$refs.page.click()
      }
   }
}
